import React from 'react'
import { arrayOf, object, string, number } from 'prop-types'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'

import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import Relazsizes from 'relazsizes'

const DetailRelatedCampus = ({ sectionTitle, sponsorships, paddingTop, paddingBottom }) => (
  <div id="sponsorships" className="scholarship-sponsors">
    <SectionContainer
      className="scholarship-sponsors__content"
      backgroundColor="#fff"
      paddingBottom={paddingBottom}
      paddingTop={paddingTop}
    >
      <Container>
        <SectionTitle title={sectionTitle || 'Sponsor'} />
      </Container>
      <ThumbnailSlider>
        {
          sponsorships.map(sponsor => (
            <div className="col-md-3 col-sm-6 col-xs-12" key={`sch-thm-${sponsor.id}`}>
              <a className="scholarship-sponsors__link" href={sponsor.website} target="_blank" rel="noopener noreferer">
                <Relazsizes
                  dataSrc={sponsor.icon}
                  className="scholarship-sponsors__item"
                  alt={sponsor.title}
                />
              </a>
            </div>
          ))
        }
      </ThumbnailSlider>
    </SectionContainer>
    <style jsx>
      {`
        .scholarship-sponsors {
          position: relative;
          overflow: hidden;
          &__link {
            display: flex;
            justify-content: center;
          }
          :global(&__item) {
            max-width: 100%;
            max-height: 160px;
          }
          :global(&__content) {
            position: relative;
          }
          :global(.slick-track) {
            display: inline-flex;
            flex-wrap: nowrap;
            align-items: center;
          }
        }
      `}
    </style>
  </div>
)

DetailRelatedCampus.propTypes = {
  sponsorships: arrayOf(object),
  sectionTitle: string,
  paddingTop: number,
  paddingBottom: number,
}

DetailRelatedCampus.defaultProps = {
  sectionTitle: 'Sponsor',
  paddingTop: 80,
  paddingBottom: 80,
}

export default DetailRelatedCampus
